import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { loadImages } from '../../../../../utils/img/img';
import useServiceData from '../../../../../hooks/useServiceData';
import { useUser } from '../../../../../redux/reducer/user';

let cashedParallelPromises = null;
let cashedPromise = null;

export const useSharePreloadPromises = () => {
  const { profile } = useUser();
  const callbacks = useApplicationCallbacks();
  const { load } = useServiceData();

  const {
    getQuests,
    getGameSettings,
    getLootBoxesList,
    getParams,
    getFavoritesProducts,
    getModals,
    getIcons,
    getWishes,
    // getGuessPriceTodayList,
    // getYearStat,
    getShopPrizes,
  } = callbacks;

  const promisesArray = [
    load,
    getWishes,
    getLootBoxesList,
    getParams,
    getIcons,
    getFavoritesProducts,
    // getGuessPriceTodayList,
    // getYearStat,
    getShopPrizes,
  ];

  const parallelPromisesArray = [
    getQuests,
    getModals,
    getGameSettings,
    () =>
      loadImages(
        (profile?.items ?? []).reduce((acc, { image, is_equipped }) => (is_equipped ? [...acc, image] : acc), []),
      ),
  ];

  return () => {
    !cashedPromise && (cashedPromise = Promise.all(promisesArray.map((promise) => promise())));
    !cashedParallelPromises &&
      (cashedParallelPromises = Promise.all(parallelPromisesArray.map((promise) => promise())));
    return cashedPromise;
  };
};
